<template>
  <div id="photovoltaic-view">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width:40%;">
          <top-header
            name="topHeader"
            :PageTitle="PageTitle"
            ActiveMenuIndex="Photovoltaic"
          />
        </div>
        <div style="width:60%;" class="block-top-button-container"></div>
      </div>
      <div class="block-top-line"></div>
      <div class="main-content">
        <div class="block-top-bottom-content">
          <div class="block-top-button">
            <el-select
              v-model="selectedSite"
              placeholder="选择电站"
              v-loading="isLoadingSite"
              @change="queryData()"
              style="margin-right:10px;"
            >
              <el-option
                v-for="item in SiteList"
                :key="item.ID"
                :label="item.SiteName"
                :value="item.SiteId"
              ></el-option>
            </el-select>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择起始时间"
              v-model="selectedStartDate"
              style="margin-right:10px;"
            ></el-date-picker>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择结束时间"
              v-model="selectedEndDate"
            ></el-date-picker>
            <el-button
              type="primary"
              icon="el-icon-refresh"
              style="height:40px;margin-left:10px;margin-right:30px;"
              @click="queryData()"
              >查 询</el-button
            >
          </div>
          <div class="route-content">
            <div class="block-top-content" style="height:100%;">
              <el-table
                :data="tableData"
                v-loading="isLoadingData"
                style="fontSize:18px;"
                height="90%"
              >
                <el-table-column
                  prop="SiteName"
                  label="电站"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="SiteId"
                  label="电站ID"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="Date"
                  label="日期"
                  sortable
                  :formatter="formatDate"
                ></el-table-column>
                <el-table-column
                  prop="EnergyValue"
                  label="当日发电量"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="Radiant"
                  label="辐照率"
                ></el-table-column>
                <el-table-column
                  prop="MaxPower"
                  label="当日最大功率"
                ></el-table-column>
                <el-table-column
                  prop="SaveTime"
                  label="保存时间"
                  :formatter="formatDateTime"
                ></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import request from "@/utils/request";
import topHeader from "../TopMenu/topHeader";
import moment from "moment";

export default {
  name: "EnergyPerImport",
  components: {
    topHeader
  },
  data() {
    return {
      PageTitle: "光伏电站数据",
      SiteList: [],
      selectedSite: "",
      isLoadingSite: false,
      selectedStartDate: "",
      selectedEndDate: "",
      tableData: [],
      isLoadingData: false
    };
  },
  created() {
    let startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    startDate.setFullYear(2020);
    startDate.setMonth(10);
    startDate.setDate(1);
    this.selectedStartDate = startDate;
    let endDate = new Date();
    endDate.setFullYear(2020);
    endDate.setMonth(10);
    endDate.setDate(30);
    this.selectedEndDate = endDate;
  },
  mounted() {
    const { querySiteList, queryData } = this;
    querySiteList();
  },
  methods: {
    querySiteList() {
      this.isLoadingSite = true;
      request({
        url: "MstPhotovoltaicSite/GetSites",
        method: "post"
      })
        .then(res => {
          this.SiteList = res.data.Data;
          if (res.data.Data && res.data.Data.length > 0) {
            this.selectedSite = res.data.Data[0].SiteId;
            this.queryData();
          }
        })
        .finally(() => {
          this.isLoadingSite = false;
        });
    },
    queryData() {
      if (this.selectedSite == "") {
        this.$message.info("请先选择光伏电站！");
        return;
      }
      this.isLoadingData = true;
      let postArgs = {
        SiteId: this.selectedSite,
        StartDate: this.selectedStartDate,
        EndDate: this.selectedEndDate
      };
      request({
        url: "APPPhotovoltaicDay/GetPhotovoltaicDays",
        method: "post",
        data: postArgs
      })
        .then(response => {
          const res = response;
          if (res.data.Data != undefined) {
            this.tableData = res.data.Data;
          }
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    formatDate:function(row,column){
      var date = row[column.property];
      if(date === undefined){
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    formatDateTime:function(row,column){
      var date = row[column.property];
      if(date === undefined){
        return ''
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    }
  }
};
</script>
<style lang="less" scoped>
#photovoltaic-view {
  width: 100%;
  height: 100%;
  background-color: #1b2445;
  color: #fff;
  #dv-full-screen-container {
    //background-image: url("./img/bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1b2445;
  }
  .block-top-line {
    //background-color: #1D2647;
    background-color: #313c5e;
    width: 100%;
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #1b2445;
  }
  .route-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-right: 30px;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 35%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 45%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    flex: 1;
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-button-container {
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
  }
  .block-top-button {
    height: 40px;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    background-color: #1b2445;
    height: 50px;
    justify-content: flex-end;
    align-items: center;
  }
  .block-top-button-field {
    background-color: #1b2445;
    margin-top: 15px;
    margin-left: 10px;
  }
  .block-top-button-field /deep/ .el-input__inner {
    background-color: #1b2445;
    color: #fff !important;
  }
  .block-top-model {
    height: 100px;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .el-table__body tr.current-row > td {
    color: #fff;
    background-color: #a2a4a7 !important;
  }
}

#formEnergyPerImportMonthList div.el-form-item__content {
  width: 80% !important;
}

.el-cascader .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
  font-size: 22px;
}
.el-cascader .el-cascader__tags .el-tag {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
}
</style>
